{
  "backend.title": "Administración",
  "backend.users": "Usuarios y permisos"
}
